import React from 'react';
import { 
  Server, 
  HardDrive, 
  Wifi, 
  Smartphone, 
  Cloud, 
  Network, 
  Globe, 
  Phone, 
  Wrench, 
  TabletSmartphone,
  Cable,
  Video,
  Radio,
  Navigation,
  Palette,
  Bot
} from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { useNavigate } from 'react-router-dom';

const Services = () => {
  const navigate = useNavigate();

  const services = [
    { icon: Bot, title: 'AI & Automation', tagline: 'Less busywork, more of the stuff that matters — we find where AI actually helps and set it up properly', link: null },
    { icon: Server, title: '24/7 Server Monitoring & Backup', tagline: 'We watch your systems so you don\'t have to — issues caught and fixed before you even notice', link: '/server-monitoring' },
    { icon: HardDrive, title: 'Hardware & Software Supply & Configuration', tagline: 'The right kit, set up properly, delivered ready to work — no jargon, no guesswork', link: '/hardware-supply' },
    { icon: Palette, title: 'Web and App Design & Production', tagline: 'Websites and apps built around your business, not a template', link: '/websites-apps' },
    { icon: Wifi, title: 'Internet of Things / eSIMs / Smart Devices', tagline: 'Connected devices that actually work together — we handle the complexity', link: null },
    { icon: Smartphone, title: 'Mobile Telecoms - Vodafone, O2 & EE', tagline: 'Better deals and better support than going direct — we manage it all for you', link: '/voip-telecoms' },
    { icon: Cloud, title: 'Microsoft 365 Licences', tagline: 'The right licences for your team, properly configured, not just switched on and left', link: '/microsoft-365' },
    { icon: Network, title: 'Network Design, Support & Implementation', tagline: 'Reliable networks built for how your business actually works, not how a textbook says it should', link: null },
    { icon: Globe, title: 'Domain Name Registration & Web Hosting', tagline: 'Your online presence, looked after — no surprise renewals or downtime', link: null },
    { icon: Phone, title: 'Hosted VoIP - Gamma Horizon', tagline: 'Crystal-clear business calls from anywhere — we set it up and keep it running', link: '/voip-telecoms' },
    { icon: Wrench, title: 'Computer / Tablet Repairs', tagline: 'Fast turnaround repairs by people who explain the problem in plain English', link: '/it-support' },
    { icon: TabletSmartphone, title: 'Android & Apple Devices - Mobile & Tablet', tagline: 'Setup, security and support across iOS and Android — managed alongside your Windows environment', link: null },
    { icon: Cable, title: 'Ethernet / Leased Lines', tagline: 'Structured cabling and dedicated connectivity — tidy, tested, and built to last', link: null },
    { icon: Video, title: 'Conference Audio & Visual', tagline: 'Meeting rooms that work first time, every time — no "can you hear me?" moments', link: null },
    { icon: Radio, title: 'Mobile Repeaters', tagline: 'Poor signal at your premises? We fix it properly, not with a bodge', link: null },
    { icon: Navigation, title: 'Vehicle Tracking', tagline: 'Know where your fleet is and how it\'s performing — simple, reliable tracking', link: null }
  ];

  return (
    <section id="services" className="py-24 bg-gradient-to-b from-white to-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4">
            Our Services
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">
            IT and telecoms support that speaks your language — no jargon, no hard sell, just solutions that fit your business
          </p>
          <p className="text-sm text-slate-500 mt-3 max-w-xl mx-auto">
            Based in Glossop, proudly serving businesses across Manchester, Stockport, Tameside, High Peak and the wider Northwest of England.
          </p>
        </div>
        <div className="flex flex-wrap justify-center gap-4">
          {services.map((service) => (
            <Card
              key={service.title}
              onClick={() => service.link && navigate(service.link)}
              className={`group hover:shadow-xl transition-all duration-300 border border-slate-200 hover:border-blue-500 bg-white hover:-translate-y-1 w-full sm:w-[calc(50%-8px)] lg:w-[calc(33.333%-11px)] xl:w-[calc(25%-12px)] ${service.link ? 'cursor-pointer' : ''}`}
            >
              <CardContent className="p-5">
                <div className="flex flex-col items-center text-center">
                  <div className={`p-3 bg-gradient-to-br from-blue-50 to-cyan-50 rounded-xl mb-3 group-hover:scale-110 transition-transform duration-300`}>
                    <service.icon className="w-6 h-6 text-blue-600" />
                  </div>
                  <h3 className="text-xs font-semibold text-slate-800 leading-relaxed group-hover:text-blue-600 transition-colors">
                    {service.title}
                  </h3>
                  <p className="text-[11px] text-slate-500 mt-1.5 leading-snug">{service.tagline}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;